import { Injectable, inject } from '@angular/core';
import { type EscapeClosable, EscapeHandler, FileUtilService } from '@reconcept-platform/shared/util';

export type FilePreviewType = 'unknown' | 'office' | 'pdf' | 'image' | 'audio' | 'video';
export type FilePreviewView = 'main' | 'image' | 'iframe' | 'audio' | 'video';

@Injectable({
  providedIn: 'root',
})
export class FilePreviewService implements EscapeClosable {
  private fileUtil = inject(FileUtilService);
  private escHandler = inject(EscapeHandler);

  filePreviewOptions: {
    view: FilePreviewView;
    originalFileURL: string;
    previewFileURL: string;
    previewType: FilePreviewType;
  };

  public filePreviewIsShown = false;

  canShowPreview(contentType: string, fileName: string) {
    return !!this.getPreviewType(contentType, fileName);
  }

  // show form type select modal
  showFilePreview(fileURL: string, contentType?: string) {
    // @ts-expect-error TS2345 argument not assignable
    const previewTypeBasedOnContentType = this.getPreviewType(contentType, fileURL);
    const previewType: FilePreviewType = previewTypeBasedOnContentType?.previewType ?? 'unknown';
    const view: FilePreviewView = previewTypeBasedOnContentType?.view ?? 'main';

    this.filePreviewOptions = {
      view: view,
      originalFileURL: fileURL,
      // @ts-expect-error TS2345 argument not assignable
      previewFileURL: this.fileUtil.getPreviewFileURL(fileURL, contentType),
      previewType: previewType,
    };

    // open select screen
    this.filePreviewIsShown = true;

    this.escHandler.register(this);
  }

  hideFilePreview() {
    this.filePreviewIsShown = false;
    this.escHandler.unregister(this);
  }

  closeByEscape() {
    this.hideFilePreview();
  }

  private getPreviewType(
    contentType: string,
    fileName: string,
  ): { previewType: FilePreviewType; view?: FilePreviewView } {
    if (this.fileUtil.isOfficeFile(contentType)) {
      return { previewType: 'office' };
    } else if (this.fileUtil.isPDF(fileName)) {
      return { previewType: 'pdf' };
    } else if (this.fileUtil.isAudioFile(contentType)) {
      return { previewType: 'audio', view: 'audio' };
    } else if (this.fileUtil.isVideoFile(contentType)) {
      return { previewType: 'video', view: 'video' };
    } else if (this.fileUtil.isImageFile(contentType, fileName)) {
      return { previewType: 'image', view: 'image' };
    }

    // @ts-expect-error TS2322 type not assignable
    return null;
  }
}
